import React from 'react'
import Radium from 'radium'

import { ReactComponent as WalletIcon } from '../../../assets/wallet.svg'
import { ReactComponent as PlantIcon } from '../../../assets/plant.svg'
import { ReactComponent as PiggyBankIcon } from '../../../assets/piggy-bank.svg'

import Width from '../../Width'
import Item from './Item/index'

export default Radium(() => (
  <Width>
    {({ isSmall }) => (
      <div style={[styles.container, isSmall && styles.small.container]}>
        <Item to='/income' icon={PlantIcon}>
          Income
        </Item>
        <Item to='/monthly-expenses' icon={WalletIcon}>
          Monthly expenses
        </Item>
        <Item to='/annual-expenses' icon={WalletIcon}>
          Annual expenses
        </Item>
        <Item to='/monthly-savings' icon={PiggyBankIcon}>
          Monthly savings
        </Item>
      </div>
    )}
  </Width>
))

const styles = {
  container: {
    width: '100%',
    maxWidth: '220px',
    marginRight: '10px',
  },
  small: {
    container: {
      display: 'flex',
      maxWidth: 'initial',
      marginRight: 0,
      paddingBottom: '30px',
    },
  },
}
